export default "__VITE_ASSET__vh6pgS0r__"